import { Model, Factory } from 'miragejs'
import type { ModelDefinition } from 'miragejs/-types'
import { randChanceBoolean, randNumber, randProductName } from '@ngneat/falso'
import type { SchemaAttributes } from '../types.js'
import type { MirageServer, MockServer } from './server.js'
import { getQueryParamValue, pageable } from './utils.js'

type SimpleBundleAttributes = SchemaAttributes<'SimpleBundle'>

export const model = Model as ModelDefinition<SimpleBundleAttributes>

export const factory = Factory.extend<SimpleBundleAttributes>({
  name() {
    return randProductName()
  },
  archived() {
    return randChanceBoolean({ chanceTrue: 0.3 })
  },
  draft() {
    return randChanceBoolean({ chanceTrue: 0.3 })
  },
  display_price() {
    return randNumber({ min: 10, max: 500, precision: 2 })
  },
})

export function routes(server: MockServer) {
  server.get(
    '/consultations/:parent_lookup_consultation/bundles/search',
    function (this: MirageServer, schema, request) {
      const bundles = schema.all('simpleBundle')
      const searchTerm =
        getQueryParamValue(request.queryParams?.['filter[search]']) || ''
      const filteredBundles = bundles.filter((bundle) =>
        bundle.name.toLowerCase().includes(searchTerm.toLowerCase()),
      )
      const { data, meta } = pageable(filteredBundles, request)
      return {
        ...this.serialize(data),
        meta: {
          pagination: meta,
        },
      }
    },
  )
}

export function seeds(server: MockServer) {
  server.create('simpleBundle', {
    name: 'Simple bundle test 1',
    archived: false,
    draft: false,
    display_price: 1000.99,
  })
  server.create('simpleBundle', {
    name: 'Simple bundle test 2',
    archived: false,
    draft: false,
    display_price: 190.63,
  })
}
